import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalGeolocationAuthorizationError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalGeolocationAuthorizationError';
  }
}
